import { styled } from "@acko-tech/building-blocks.ui.common";
import { device } from "@utils/screens";

export const Container = styled.div`
  width: calc(100% - 64px);
  margin: 0 32px 20px;

  @media ${device.tablet} {
    margin: 0 0 20px;
    width: 100%;
  }
`;

export const RowWrapper = styled.div`
  &:last-child div {
    border-bottom: none;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  cursor: pointer;
  border-bottom: 1px dashed #e7e7f0;
  padding-bottom: 16px;
`;

export const Title = styled.div`
  font-family: Euclid Circular B;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
  color: #040222;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
`;

export const Description = styled.div`
  font-family: Euclid Circular B;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  color: #5b5675;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100% - 30px);
`;

export const SearchTitle = styled.div`
  color: #121212;
  font-family: "Euclid Circular B";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 20px;
`;
